const quizData = [
    {
        question: "What is the name of the Lannister ancestral seat?",
        options: [
            "Storm's End",
            "Highgarden",
            "Casterly Rock",
            "Riverrun"
        ],
        answer: "Casterly Rock"
    },
    {
        question: "Who was the Lord Commander of the Night's Watch before Jon Snow?",
        options: [
            "Maester Aemon",
            "Qhorin Halfhand",
            "Alliser Thorne",
            "Jeor Mormont"
        ],
        answer: "Jeor Mormont"
    },
    {
        question: "What is the name of the temple in Braavos where the Faceless Men train?",
        options: [
            "The Citadel",
            "The Iron Bank",
            "The Red Keep",
            "The House of Black and White"
        ],
        answer: "The House of Black and White"
    }
];
const questionElement = document.getElementById("question");
const optionsElement = document.getElementById("options");
const nextButton = document.getElementById("next-btn");
const resultContainer = document.getElementById("result-container");
const quizItemContainer = document.getElementById("quiz-item-container");
const scoreElement = document.getElementById("score");
const restartButton = document.getElementById("restart-btn");
const timeLeftElement = document.getElementById("time-left");
const progressBar = document.querySelector(".progress-bar");
let highscore = 0;
let timeLeft;
let timeInterval;
init();
function init() {
    currentQuestionIndex = 0;
    score = 0;
    shuffleArray(quizData);
    loadQuestion();
    quizItemContainer.style.display = "block";
    resultContainer.style.display = "none";
    progressBar.style.width = 0;
}
function startTimer() {
    timeLeft = 10;
    timeLeftElement.textContent = timeLeft;
    timeInterval = setInterval(()=>{
        timeLeft--;
        timeLeftElement.textContent = timeLeft;
        if (timeLeft === 0) {
            clearInterval(timeInterval);
            handleTimeout();
        }
    }, 1000);
}
function handleTimeout() {
    Array.from(optionsElement.children).forEach((btn)=>btn.disabled = true);
    nextButton.style.display = "block";
}
function updateProgressBar() {
    const progressPercentage = currentQuestionIndex / quizData.length * 100;
    progressBar.style.width = progressPercentage + "%";
}
function loadQuestion() {
    startTimer();
    const currentQuestion = quizData[currentQuestionIndex];
    questionElement.textContent = currentQuestion.question;
    optionsElement.innerHTML = "";
    currentQuestion.options.forEach((option)=>{
        const button = document.createElement("button");
        button.classList.add("option");
        button.textContent = option;
        optionsElement.appendChild(button);
        button.addEventListener("click", ()=>selectAnswer(option, button));
    });
    nextButton.style.display = "none";
}
function selectAnswer(selectedOption, button) {
    clearInterval(timeInterval); // Stop the timer when an answer is selected
    const correctAnswer = quizData[currentQuestionIndex].answer;
    // console.log(correctAnswer);
    if (selectedOption === correctAnswer) {
        button.classList.add("correct");
        score++;
    } else button.classList.add("wrong");
    handleTimeout();
}
nextButton.addEventListener("click", ()=>{
    currentQuestionIndex++;
    updateProgressBar();
    if (currentQuestionIndex < quizData.length) loadQuestion();
    else loadResults();
});
function loadResults() {
    quizItemContainer.style.display = "none";
    resultContainer.style.display = "block";
    setHighscore();
    scoreElement.innerHTML = `score: ${score}/ ${quizData.length} <br> highscore: ${highscore}`;
    restartButton.style.display = "block";
}
restartButton.addEventListener("click", init);
const setHighscore = function() {
    if (score > highscore) highscore = score;
};
function shuffleArray(array) {
    for(let i = array.length - 1; i > 0; i--){
        // Pick a random index from 0 to i
        const j = Math.floor(Math.random() * (i + 1));
        // Swap the elements at indices i and j
        [array[i], array[j]] = [
            array[j],
            array[i]
        ];
    }
    return array;
}

//# sourceMappingURL=quiz.10521165.js.map
